/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode"; // Correct importation
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  CUSTOMER_LOGIN: "/api/customer/customer_login",
  CUSTOMER_REGISTER: "/api/customer/customer_register",
  LOGOUT: "/api/customer/logout",
  CUSTOMER_ACCOUNT_VERIFICATION: "/api/customer/verify",
  SELLER_PROFILE_REGISTER: "/api/customer/createSellerAccount",
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// Action pour l'inscription du client
export const customer_register = createAsyncThunk(
  "auth/customer_register",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.CUSTOMER_REGISTER, info, {
        withCredentials: true,
      });
      localStorage.setItem("customerToken", data.token);
      //console.log("Info utilisateur :", data);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'inscription du client :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Action pour la connexion du client
/*export const customer_login = createAsyncThunk(
    "auth/customer_login",
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.CUSTOMER_LOGIN, info, { withCredentials: true });
            localStorage.setItem("customerToken", data.token);
            console.log("Info utilisateur :", data);
            return fulfillWithValue(data);
        } catch (error) {
            //console.error("Erreur lors de la connexion client :", error);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);*/

export const customer_login = createAsyncThunk(
  "auth/customer_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.CUSTOMER_LOGIN, info, {
        withCredentials: true,
      });
      localStorage.setItem("customerToken", data.token);
      // console.log("Info utilisateur :", data);
      return fulfillWithValue(data);
    } catch (error) {
      // Correction ici
      if (error.response && error.response.data) {
        // on envoie tout l'objet d'erreur du backend
        return rejectWithValue(error.response.data);
      } else {
        // fallback si pas de réponse serveur
        return rejectWithValue({ message: error.message });
      }
    }
  },
);

// Action pour la déconnexion
export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.LOGOUT, {
        withCredentials: true,
      });
      localStorage.removeItem("customerToken");
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Erreur lors de la déconnexion :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Action pour la déconnexion
export const customer_account_Verification = createAsyncThunk(
  "auth/customer_account_Verification",
  async ({ customerId, otp }, { rejectWithValue, fulfillWithValue }) => {
    try {
      // const { data } = await api.post(API_ROUTES.LOGOUT, { withCredentials: true });
      const { data } = await api.get(
        `${API_ROUTES.CUSTOMER_ACCOUNT_VERIFICATION}/${customerId}/${otp}`,
        { withCredentials: true },
      );
      localStorage.setItem("customerToken", data.token);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const createSellerAccount = createAsyncThunk(
  "auth/createSellerAccount",
  async (profileInfo, { rejectWithValue, fulfillWithValue }) => {
    //console.log('profil info', profileInfo)
    try {
      const { data } = await api.post(
        API_ROUTES.SELLER_PROFILE_REGISTER,
        profileInfo,
        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de creation :", error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const authReducer = createSlice({
  name: "auth",
  initialState: {
    successMessage: "",
    messageError: "",
    loader: false,
    /* customerInfo: localStorage.getItem("customerToken")
            ? jwtDecode(localStorage.getItem("customerToken"))
            : null, // Décode le token pour remplir `customerInfo` si possible
        token: localStorage.getItem("customerToken") || "",*/
    customerInfo: null,
    token: "",
    newCustomerId: "",
    roleSecond: "",
    verifiedMessage: "",
    userInfo: {},
    loginSuccess: "",
  },
  reducers: {
    setCustomerInfo: (state, action) => {
      state.customerInfo = action.payload;
    },
    setUserInfo: (state, action) => {
      // to become seller
      state.userInfo = action.payload;
    },
    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
      state.verifiedMessage = "";
      state.loginSuccess = "";
    },
    setCustomerData: (state, action) => {
      const { token } = action.payload;
      localStorage.setItem("customerToken", token);
      state.token = token;
      try {
        state.customerInfo = jwtDecode(token);
        state.roleSecond = "seller";
      } catch (error) {
        state.messageError = "Impossible de décoder le token client.";
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(customer_register.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(customer_register.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.newCustomerId = action.payload.newCustomerId;
        /*  state.token = action.payload.token;
               try {
                    state.customerInfo = jwtDecode(action.payload.token);
                } catch (decodeError) {
                    //console.error("Erreur lors du décodage du token :", decodeError);
                    state.messageError = "Impossible de décoder le token.";
                }*/
      })
      .addCase(customer_register.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload || "Une erreur est survenue.";
      })

      .addCase(customer_login.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(customer_login.fulfilled, (state, action) => {
        state.loader = false;
        state.loginSuccess = action.payload.message || "logged in";
        state.token = action.payload.token;
        state.roleSecond = action.payload.roleSecond;
        try {
          state.customerInfo = jwtDecode(action.payload.token);
        } catch (decodeError) {
          // console.error("Erreur lors du décodage du token :", decodeError);
          state.messageError = "Impossible de décoder le token.";
        }
      })
      .addCase(customer_login.rejected, (state, action) => {
        state.loader = false;
        state.messageError =
          action.payload?.message || "Une erreur est survenue.";
        state.newCustomerId = action.payload?.newCustomerId || null;
      })
      .addCase(customer_account_Verification.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(customer_account_Verification.fulfilled, (state, action) => {
        state.loader = false;
        state.verifiedMessage = action.payload.message;
        state.newCustomerId = null;
        state.token = action.payload.token;
        /* try {
                    state.customerInfo = jwtDecode(action.payload.token);
                } catch (decodeError) {
                   // console.error("Erreur lors du décodage du token :", decodeError);
                    state.messageError = "Impossible de décoder le token.";
                }*/
      })
      .addCase(customer_account_Verification.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload || "Une erreur est survenue.";
        state.newCustomerId = action.payload?.newCustomerId || null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loader = false;
        state.token = ""; // Réinitialise le token
        state.customerInfo = null; // Réinitialise les informations utilisateur
        state.loginSuccess = "";
      })

      .addCase(createSellerAccount.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(createSellerAccount.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.userInfo = {
          ...state.userInfo,
          ...action.payload.userInfo,
        };
        state.newCustomerId = action.payload?.newCustomerId;
      })
      .addCase(createSellerAccount.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      });
  },
});

export const { setCustomerData, setCustomerInfo, setUserInfo, messageClear } =
  authReducer.actions;
export default authReducer.reducer;
